import Main from '@/components/main';

export default [
  {
    path: '/communicate',
    name: 'communicate',
    component: Main,
    meta: {
      notCache: true,
      badge: true
      //access: ['qiye'],
    },
    children: [
      {
        path: '/communicate/index',
        name: 'communicateIndex',
        meta: {
          title: '消息',
          notCache: true,
          icon: 'bianzu8'
        },
        component: () => import('@/view/qiye/communicate/index')
      }
    ]
  },
  {
    path: '/zhiwei',
    name: 'zhiwei',
    component: Main,
    meta: {
      title: '岗位管理',
      icon: 'shouye'
      //access: ['qiye'],
    },
    children: [
      {
        path: '/zhiwei/index',
        name: 'zhiweiIndex',
        meta: {
          title: '岗位管理',
          notCache: true,
          icon: 'shouye'
        },
        component: () => import('@/view/qiye/zhiwei/index')
      },
      {
        path: '/zhiwei/edit',
        name: 'zhiweiEdit',
        meta: {
          hideInMenu: true,
          title: '新增/编辑岗位',
          notCache: true,
          icon: 'shouye'
        },
        component: () => import('@/view/qiye/zhiwei/edit')
      }
    ]
  },
  {
    path: '/jianli',
    name: 'jianli',
    component: Main,
    meta: {
      notCache: true
      //access: ['qiye'],
    },
    children: [
      {
        path: '/jianli/index',
        name: 'jianliIndex',
        meta: {
          title: '简历投递',
          notCache: true,
          icon: 'bianzu3'
        },
        component: () => import('@/view/qiye/jianli/index')
      }
    ]
  },

  {
    path: '/zhaoren',
    name: 'zhaoren',
    component: Main,
    meta: {
      notCache: true
    },
    children: [
      {
        path: '/zhaoren/index',
        name: 'zhaorenIndex',
        meta: {
          title: '我要招人',
          notCache: true,
          icon: 'bianzu3'
        },
        component: () => import('@/view/qiye/zhaoren/index')
      }
    ]
  },
  {
    path: '/niuren',
    name: 'niuren',
    component: Main,
    meta: {
      notCache: true
      //access: ['qiye'],
    },
    children: [
      {
        path: '/niuren/index',
        name: 'niurenIndex',
        meta: {
          title: '人才库',
          notCache: true,
          icon: 'bianzu7'
        },
        component: () => import('@/view/qiye/niuren/index')
      }
    ]
  },
  {
    path: '/interview',
    name: 'interview',
    component: Main,
    meta: {
      notCache: true
    },
    children: [
      {
        path: '/interview/index',
        name: 'interviewIndex',
        meta: {
          title: '面试记录',
          icon: 'mianshijilu',
          notCache: true
        },
        component: () => import('@/view/qiye/user/interview')
      }
    ]
  },
  {
    path: '/qiye/zhaopinhui',
    name: 'qiyeZhaopinhui',
    component: Main,
    meta: {
      notCache: true
      //access: ['qiye'],
    },
    children: [
      {
        path: '/qiye/zhaopinhui/index',
        name: 'qiyeZhaopinhuiIndex',
        meta: {
          title: '会招聘',
          notCache: true,
          icon: 'xingzhuangjiehe2'
        },
        component: () => import('@/view/qiye/zhaopinhui/index')
      },
      {
        path: 'qiye/zhaopinhui/edit',
        name: 'qiyeZhaopinhuiEdit',
        meta: {
          hideInMenu: true,
          title: '招聘会详情',
          notCache: true,
          icon: 'fabu'
        },
        component: () => import('@/view/qiye/zhaopinhui/edit')
      }
    ]
  },
  {
    path: '/help',
    name: 'help',
    component: Main,
    meta: {
      notCache: true,
      title: '就业帮扶',
      icon: 'bianzu10'
    },
    children: [
      {
        path: '/help/apply',
        name: 'HelpManage',
        meta: {
          title: '报名中心',
          notCache: true,
          helpBadge: true
        },
        component: () => import('@/view/qiye/help-apply/index')
      },
      {
        path: '/help/plan',
        name: 'HelpPlan',
        meta: {
          title: '帮扶计划',
          notCache: true
        },
        component: () => import('@/view/qiye/help-plan/index')
      },
      {
        path: '/help/project-edit',
        name: 'HelpProjectEdit',
        meta: {
          hideInMenu: true,
          title: '帮扶计划',
          notCache: true
        },
        component: () => import('@/view/qiye/help-plan/project-edit')
      },
      {
        path: '/help/project-detail',
        name: 'HelpProjectDetail',
        meta: {
          hideInMenu: true,
          title: '帮扶计划',
          notCache: true
        },
        component: () => import('@/view/qiye/help-plan/project-detail')
      },
      {
        path: '/help/datas',
        name: 'HelpDatas',
        meta: {
          title: '帮扶统计',
          notCache: true
        },
        component: () => import('@/view/qiye/help-datas/index')
      }
    ]
  },
  {
    path: '/mycompany',
    name: 'mycompany',
    component: Main,
    meta: {
      hideInMenu: false,
      notCache: true,
      title: '企业管理',
      icon: 'bianzu10'
    },
    children: [
      {
        path: '/friend/index',
        name: 'friendIndex',
        meta: {
          title: '同事管理',
          notCache: true,
          access: ['isCompanyMainAdmin']
        },
        component: () => import('@/view/qiye/friend/index')
      },
      {
        path: '/mycompany/info',
        name: 'mycompany-info',
        meta: {
          hideInMenu: false,
          title: '企业信息',
          notCache: true,
          access: ['isCompanyMainAdmin']
        },
        component: () => import('@/view/qiye/info/newdetail')
      },

      {
        path: '/mycompany/edit',
        name: 'mycompany-edit',
        meta: {
          title: '企业基本信息',
          notCache: true,
          hideInMenu: true,
          access: ['isCompanyMainAdmin']
        },
        component: () => import('@/view/qiye/info/edit')
      },
      {
        path: '/name/card',
        name: 'name-card',
        meta: {
          hideInMenu: true,
          title: '创建招聘者名片',
          notCache: true,
          icon: 'bianzu4'
        },
        component: () => import('@/view/qiye/info/name_card')
      },
      {
        path: '/ziliao/index',
        name: 'ziliaoIndex',
        meta: {
          title: '个人信息',
          icon: 'bianzu4',
          notCache: true
        },
        component: () => import('@/view/qiye/ziliao/index')
      },
      {
        path: '/ziliao/edit',
        name: 'ziliao-edit',
        meta: {
          hideInMenu: true,
          title: '个人信息',
          notCache: true
        },
        component: () => import('@/view/qiye/ziliao/edit')
      }
    ]
  },

  // {
  //   path: '/yijian',
  //   name: 'yijian',
  //   component: Main,
  //   meta: {
  //     notCache: true
  //     //access: ['qiye'],
  //   },
  //   children: []
  // },
  {
    path: '/datas',
    name: 'datas',
    component: Main,
    meta: {
      notCache: true
      //access: ['qiye'],
    },
    children: [
      {
        path: '/datas/index',
        name: 'datasIndex',
        meta: {
          title: '招聘数据',
          notCache: true,
          icon: 'bianzu11'
        },
        component: () => import('@/view/qiye/datas/index')
      }
    ]
  },
  {
    path: '/issue',
    name: 'issue',
    component: Main,
    meta: {
      title: '评价与反馈',
      notCache: true,
      icon: 'tousubeifen'
    },
    children: [
      {
        path: '/issue/index',
        name: 'isTurnByHref_https://www.wjx.cn/vm/O7Zmb0Q.aspx# ',
        meta: {
          title: '评价',
          notCache: true
        }
        // component: () => import('@/view/qiye/issue/index')
      },
      {
        path: '/yijian/index',
        name: 'yijianIndex',
        meta: {
          title: '反馈',
          notCache: true
        },
        component: () => import('@/view/qiye/yijian/index')
      }
    ]
  },
  {
    path: '/communication',
    name: 'communication',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/communication/index',
        name: 'communicationIndex',
        meta: {
          title: '已经沟通',
          notCache: true
        },
        component: () => import('@/view/qiye/user/communication')
      }
    ]
  },

  {
    path: '/collection',
    name: 'collection',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/collection/index',
        name: 'collectionIndex',
        meta: {
          title: '我的收藏',
          notCache: true
        },
        component: () => import('@/view/qiye/user/collection')
      }
    ]
  },
  {
    path: '/recommend',
    name: 'recommend',
    component: Main,
    meta: {
      hideInMenu: true,
      notCache: true
    },
    children: [
      {
        path: '/recommend/index',
        name: 'recommendIndex',
        meta: {
          title: '工会推荐',
          notCache: true
        },
        component: () => import('@/view/qiye/user/recommend')
      }
    ]
  }
];
